import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Confirm modal.
 */
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  // Modal title
  @Input() title: string = '';

  // Modal title class
  @Input() titleClass: string = '';

  // Modal description
  @Input() description: string = '';

  // Modal description in HTML
  @Input() dangerousHTML: string = '';

  // Confirm button class
  @Input() confirmBtnClass: string = 'btn-success';

  //Confirm button text
  @Input() confirmBtnText: string = 'Yes';

  // Cancel button class
  @Input() cancelBtnClass: string = 'btn-light';

  // Cancel button text
  @Input() cancelBtnText: string = 'No';

  // Cancel event emitter
  @Output() cancel = new EventEmitter<number>();

  // Confirm event emitter
  @Output() confirm = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
